import Vue from 'vue'
import Router from 'vue-router'
import authService from '../services/authenticationService'

// Polyfill for endsWith
if (!String.prototype.endsWith) {
// eslint-disable-next-line no-extend-native
  String.prototype.endsWith = function (search, length) {
    if (length === undefined || length > this.length) {
      length = this.length
    }
    return this.substring(length - search.length, length) === search
  }
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/contact',
      component: resolve => import(`@/components/Contact.vue`).then(resolve)
    },
    {
      path: '/cookiePolicy',
      component: resolve => import(`@/components/CookiePolicy`).then(resolve)
    },
    {
      path: '/',
      name: 'home',
      component: resolve => import(`@/components/Home`).then(resolve)
    },
    {
      path: '/polls/:poll',
      name: 'answerpoll',
      component: resolve => import(`@/components/RecordResponseView`).then(resolve),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: resolve => import(`@/components/PrivacyPolicy`).then(resolve)
    },
    {
      path: '/terms-of-service',
      name: 'termsOfService',
      component: resolve => import(`@/components/TermsOfService`).then(resolve)
    },
    {
      path: '/signin',
      name: 'signin',
      component: resolve => import(`@/components/SignIn`).then(resolve)
    },
    {
      path: '/userProfile',
      name: 'userProfile',
      component: resolve => import('@/components/UserProfile').then(resolve),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/groups/:groupId',
      name: 'groups',
      component: resolve => import('@/components/GroupPollsView').then(resolve),
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.params.poll && to.params.poll.length > 20 && to.params.poll.endsWith('-IPC')) {
    next()
  } else {
    const currentUser = authService.getCurrentUser()
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth && !currentUser) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      })
    } else if (requiresAuth && currentUser) {
      next()
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js